<p>price-book works!</p>
